function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import { UI } from "../../../builderUiTheme";
import { SPACING_SIDES, RADIUS_CORNERS, RADIUS_UNITS, SIZE_UNITS, SIZE_KEYWORD_UNITS, MAX_WIDTH_UNITS, SPACING_UNITS, OFFSET_SIDES, SPACING_SLIDER_MAX, SPACING_INPUT_MAX, RADIUS_SLIDER_MAX_BY_UNIT, RADIUS_INPUT_MAX_BY_UNIT, SIZE_INPUT_MAX_BY_UNIT } from "../../constants/defaultBlocks";
import { hasIndividualSpacing, hasIndividualRadius, getSpacingSideValue, getRadiusCornerLength, getSizeLength, getOffsetLength, parseCssLength, parseSizeLength, formatCssLength } from "../../utils/helpers";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SPIN_BUTTON_CSS = "\n  input.ws-builder-number-input::-webkit-outer-spin-button,\n  input.ws-builder-number-input::-webkit-inner-spin-button,\n  .ws-builder-properties input[type=number]::-webkit-outer-spin-button,\n  .ws-builder-properties input[type=number]::-webkit-inner-spin-button {\n    -webkit-appearance: none !important;\n    margin: 0 !important;\n  }\n  input.ws-builder-number-input,\n  .ws-builder-properties input[type=number] {\n    -moz-appearance: textfield !important;\n    appearance: textfield !important;\n  }\n";
var spacingInputStyle = {
  width: "100%",
  minWidth: 0,
  flex: "1 1 auto",
  background: UI.inputBg,
  border: "1px solid ".concat(UI.inputBorder),
  borderRadius: 6,
  color: UI.text,
  padding: "5px 4px 5px 6px",
  fontSize: 12,
  outline: "none",
  boxSizing: "border-box",
  MozAppearance: "textfield",
  WebkitAppearance: "none",
  appearance: "textfield"
};
var unitSelectStyle = {
  width: 46,
  minWidth: 46,
  background: UI.inputBg,
  border: "1px solid ".concat(UI.inputBorder),
  borderRadius: 6,
  color: UI.textMuted,
  padding: "5px 2px 5px 4px",
  fontSize: 11,
  outline: "none",
  cursor: "pointer",
  flexShrink: 0,
  boxSizing: "border-box"
};
function UnitSelect(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange,
    units = _ref.units,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("style", {
      children: SPIN_BUTTON_CSS
    }), /*#__PURE__*/_jsx("select", {
      value: value,
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      },
      style: _objectSpread(_objectSpread({}, unitSelectStyle), style),
      children: units.map(function (unit) {
        return /*#__PURE__*/_jsx("option", {
          value: unit,
          children: unit
        }, unit);
      })
    })]
  });
}
function LengthField(_ref2) {
  var label = _ref2.label,
    length = _ref2.length,
    units = _ref2.units,
    onChangeValue = _ref2.onChangeValue,
    onChangeUnit = _ref2.onChangeUnit,
    _ref2$allowNegative = _ref2.allowNegative,
    allowNegative = _ref2$allowNegative === void 0 ? false : _ref2$allowNegative,
    _ref2$layout = _ref2.layout,
    layout = _ref2$layout === void 0 ? "stacked" : _ref2$layout;
  var isKeyword = SIZE_KEYWORD_UNITS.includes(length.unit);
  var inputMax = SIZE_INPUT_MAX_BY_UNIT[length.unit] || 2000;
  var isRowLayout = layout === "row";
  return /*#__PURE__*/_jsxs("div", {
    style: isRowLayout ? {
      display: "grid",
      gridTemplateColumns: isKeyword ? "50px minmax(0, 1fr)" : "50px minmax(0, 1fr) 58px",
      alignItems: "center",
      gap: 6
    } : {
      display: "flex",
      flexDirection: "column",
      gap: 4
    },
    children: [label && /*#__PURE__*/_jsx("label", {
      style: {
        fontSize: isRowLayout ? 11 : 10,
        fontWeight: isRowLayout ? 600 : 400,
        color: "#6b7280",
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        whiteSpace: "nowrap"
      },
      children: label
    }), /*#__PURE__*/_jsxs("div", {
      style: isRowLayout ? {
        display: "contents"
      } : {
        display: "flex",
        alignItems: "center",
        gap: 4
      },
      children: [!isKeyword && /*#__PURE__*/_jsx("input", {
        className: "ws-builder-number-input",
        type: "number",
        min: allowNegative ? undefined : "0",
        max: inputMax,
        step: length.unit === "px" ? 1 : "any",
        value: length.value,
        onChange: function onChange(e) {
          return onChangeValue(e.target.value);
        },
        style: isRowLayout ? _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
          padding: "5px 6px",
          fontSize: 12,
          minWidth: 0
        }) : _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
          minWidth: 0
        })
      }), /*#__PURE__*/_jsx(UnitSelect, {
        value: length.unit,
        units: units,
        onChange: onChangeUnit,
        style: isRowLayout ? {
          width: "100%",
          padding: "6px 4px",
          fontSize: 12
        } : isKeyword ? {
          width: "100%",
          padding: "6px 8px",
          fontSize: 12
        } : undefined
      })]
    })]
  });
}
export function LayoutControls(_ref3) {
  var _style$zIndex;
  var style = _ref3.style,
    onUpdateSize = _ref3.onUpdateSize,
    onUpdateOffset = _ref3.onUpdateOffset,
    onUpdatePosition = _ref3.onUpdatePosition,
    onUpdateZIndex = _ref3.onUpdateZIndex,
    _ref3$showMaxWidth = _ref3.showMaxWidth,
    showMaxWidth = _ref3$showMaxWidth === void 0 ? false : _ref3$showMaxWidth;
  var width = getSizeLength(style, "width", "auto");
  var height = getSizeLength(style, "height", "auto");
  var maxWidth = getSizeLength(style, "maxWidth", "none");
  var position = (style === null || style === void 0 ? void 0 : style.position) || "static";
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 12
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 8,
        padding: 10,
        background: "#f8fafc",
        border: "1px solid ".concat(UI.inputBorder),
        borderRadius: 8
      },
      children: [/*#__PURE__*/_jsx(LengthField, {
        label: "Width",
        length: width,
        units: SIZE_UNITS,
        layout: "row",
        onChangeValue: function onChangeValue(value) {
          return onUpdateSize("width", value, width.unit);
        },
        onChangeUnit: function onChangeUnit(unit) {
          return onUpdateSize("width", width.value, unit);
        }
      }), /*#__PURE__*/_jsx(LengthField, {
        label: "Height",
        length: height,
        units: SIZE_UNITS,
        layout: "row",
        onChangeValue: function onChangeValue(value) {
          return onUpdateSize("height", value, height.unit);
        },
        onChangeUnit: function onChangeUnit(unit) {
          return onUpdateSize("height", height.value, unit);
        }
      }), showMaxWidth && /*#__PURE__*/_jsx(LengthField, {
        label: "Max Width",
        length: maxWidth,
        units: MAX_WIDTH_UNITS,
        layout: "row",
        onChangeValue: function onChangeValue(value) {
          return onUpdateSize("maxWidth", value, maxWidth.unit);
        },
        onChangeUnit: function onChangeUnit(unit) {
          var nextValue = maxWidth.unit === "none" && unit !== "none" ? 600 : maxWidth.value;
          onUpdateSize("maxWidth", nextValue, unit);
        }
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 8
      },
      children: [/*#__PURE__*/_jsx("label", {
        style: {
          fontSize: 14,
          fontWeight: 500,
          color: "#4b5563"
        },
        children: "Position"
      }), /*#__PURE__*/_jsxs("select", {
        value: position,
        onChange: function onChange(e) {
          return onUpdatePosition(e.target.value);
        },
        style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
          cursor: "pointer",
          fontSize: 13
        }),
        children: [/*#__PURE__*/_jsx("option", {
          value: "static",
          children: "Static (normal flow)"
        }), /*#__PURE__*/_jsx("option", {
          value: "relative",
          children: "Relative"
        }), /*#__PURE__*/_jsx("option", {
          value: "absolute",
          children: "Absolute (overlay)"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 8
      },
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          fontSize: 14,
          fontWeight: 500,
          color: "#4b5563"
        },
        children: "Position Offset"
      }), /*#__PURE__*/_jsx("div", {
        style: {
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 8
        },
        children: OFFSET_SIDES.map(function (side) {
          var length = getOffsetLength(style, side.key);
          return /*#__PURE__*/_jsx(LengthField, {
            label: side.label,
            length: length,
            units: SPACING_UNITS,
            allowNegative: true,
            onChangeValue: function onChangeValue(value) {
              return onUpdateOffset(side.key, value, length.unit);
            },
            onChangeUnit: function onChangeUnit(unit) {
              return onUpdateOffset(side.key, length.value, unit);
            }
          }, side.key);
        })
      })]
    }), position !== "static" && /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 4
      },
      children: [/*#__PURE__*/_jsx("label", {
        style: {
          fontSize: 14,
          fontWeight: 500,
          color: "#4b5563"
        },
        children: "Z-Index (layer)"
      }), /*#__PURE__*/_jsx("input", {
        type: "number",
        value: (_style$zIndex = style === null || style === void 0 ? void 0 : style.zIndex) !== null && _style$zIndex !== void 0 ? _style$zIndex : "",
        placeholder: "auto",
        onChange: function onChange(e) {
          return onUpdateZIndex(e.target.value);
        },
        style: spacingInputStyle
      })]
    })]
  });
}

/** Resolve one side from a CSS padding shorthand (supports 1–4 values + units). */
function getShorthandSideLength(val, side) {
  var _parts$map$side;
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var fallbackUnit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "px";
  var parts = String(val || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return parseCssLength("", fallback, fallbackUnit);
  if (parts.length === 1) return parseCssLength(parts[0], fallback, fallbackUnit);
  if (parts.length === 2) {
    return parseCssLength(side === "Top" || side === "Bottom" ? parts[0] : parts[1], fallback, fallbackUnit);
  }
  if (parts.length === 3) {
    if (side === "Top") return parseCssLength(parts[0], fallback, fallbackUnit);
    if (side === "Bottom") return parseCssLength(parts[2], fallback, fallbackUnit);
    return parseCssLength(parts[1], fallback, fallbackUnit);
  }
  var map = {
    Top: 0,
    Right: 1,
    Bottom: 2,
    Left: 3
  };
  return parseCssLength((_parts$map$side = parts[map[side]]) !== null && _parts$map$side !== void 0 ? _parts$map$side : "", fallback, fallbackUnit);
}

/** Per-column width / height / padding for column layouts. */
export function ColumnShellControls(_ref4) {
  var _ref4$widthValue = _ref4.widthValue,
    widthValue = _ref4$widthValue === void 0 ? "" : _ref4$widthValue,
    _ref4$heightValue = _ref4.heightValue,
    heightValue = _ref4$heightValue === void 0 ? "" : _ref4$heightValue,
    _ref4$paddingValue = _ref4.paddingValue,
    paddingValue = _ref4$paddingValue === void 0 ? "" : _ref4$paddingValue,
    onUpdateWidth = _ref4.onUpdateWidth,
    onUpdateHeight = _ref4.onUpdateHeight,
    onUpdatePadding = _ref4.onUpdatePadding;
  var width = parseSizeLength(widthValue || "auto", "auto");
  var height = parseSizeLength(heightValue || "auto", "auto");
  var paddingParts = String(paddingValue || "").trim().split(/\s+/).filter(Boolean);
  var linked = paddingParts.length <= 1;
  var allPadding = parseCssLength(paddingValue || "0px", 0, "px");
  var updatePaddingAll = function updatePaddingAll(value, unit) {
    onUpdatePadding(formatCssLength(value, unit));
  };
  var updatePaddingSide = function updatePaddingSide(sideKey, value, unit) {
    var next = {};
    SPACING_SIDES.forEach(function (side) {
      var length = getShorthandSideLength(paddingValue, side.key);
      next[side.key] = formatCssLength(length.value, length.unit);
    });
    next[sideKey] = formatCssLength(value, unit);
    onUpdatePadding("".concat(next.Top, " ").concat(next.Right, " ").concat(next.Bottom, " ").concat(next.Left));
  };
  var togglePaddingMode = function togglePaddingMode() {
    if (linked) {
      var v = formatCssLength(allPadding.value, allPadding.unit);
      onUpdatePadding("".concat(v, " ").concat(v, " ").concat(v, " ").concat(v));
      return;
    }
    var top = getShorthandSideLength(paddingValue, "Top");
    onUpdatePadding(formatCssLength(top.value, top.unit));
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      padding: 10,
      background: "#f8fafc",
      border: "1px solid ".concat(UI.inputBorder),
      borderRadius: 8
    },
    children: [/*#__PURE__*/_jsx(LengthField, {
      label: "Width",
      length: width,
      units: SIZE_UNITS,
      layout: "row",
      onChangeValue: function onChangeValue(value) {
        return onUpdateWidth(formatCssLength(value, width.unit));
      },
      onChangeUnit: function onChangeUnit(unit) {
        return onUpdateWidth(formatCssLength(width.value, unit));
      }
    }), /*#__PURE__*/_jsx(LengthField, {
      label: "Height",
      length: height,
      units: SIZE_UNITS,
      layout: "row",
      onChangeValue: function onChangeValue(value) {
        return onUpdateHeight(formatCssLength(value, height.unit));
      },
      onChangeUnit: function onChangeUnit(unit) {
        return onUpdateHeight(formatCssLength(height.value, unit));
      }
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 8
      },
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8
        },
        children: [/*#__PURE__*/_jsx("label", {
          style: {
            fontSize: 12,
            fontWeight: 500,
            color: "#6b7280",
            textTransform: "uppercase",
            letterSpacing: "0.04em"
          },
          children: "Padding"
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: togglePaddingMode,
          title: linked ? "Edit each side separately" : "Link all sides",
          style: {
            background: linked ? "#F2F4F7" : "#101828",
            border: "1px solid ".concat(linked ? UI.inputBorder : "#101828"),
            borderRadius: 6,
            color: linked ? "#4b5563" : "#ffffff",
            padding: "4px 10px",
            fontSize: 11,
            cursor: "pointer",
            fontWeight: 600,
            fontFamily: "DM Sans, sans-serif",
            transition: "all 0.15s"
          },
          children: linked ? "All Sides" : "Per Side"
        })]
      }), linked ? /*#__PURE__*/_jsxs("div", {
        style: {
          display: "grid",
          gridTemplateColumns: "minmax(0, 1fr) 46px",
          alignItems: "center",
          gap: 6
        },
        children: [/*#__PURE__*/_jsx("input", {
          className: "ws-builder-number-input",
          type: "number",
          min: "0",
          max: SPACING_INPUT_MAX,
          value: allPadding.value,
          onChange: function onChange(e) {
            return updatePaddingAll(e.target.value, allPadding.unit);
          },
          style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
            padding: "5px 6px",
            fontSize: 12,
            minWidth: 0
          })
        }), /*#__PURE__*/_jsx(UnitSelect, {
          value: allPadding.unit,
          units: SPACING_UNITS,
          onChange: function onChange(unit) {
            return updatePaddingAll(allPadding.value, unit);
          },
          style: {
            width: "100%",
            padding: "5px 2px 5px 4px",
            fontSize: 11
          }
        })]
      }) : /*#__PURE__*/_jsx("div", {
        style: {
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 6
        },
        children: SPACING_SIDES.map(function (side) {
          var length = getShorthandSideLength(paddingValue, side.key);
          return /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 4
            },
            children: [/*#__PURE__*/_jsx("label", {
              style: {
                fontSize: 10,
                color: "#6b7280",
                textTransform: "uppercase",
                letterSpacing: "0.04em"
              },
              children: side.label
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                alignItems: "center",
                gap: 4
              },
              children: [/*#__PURE__*/_jsx("input", {
                className: "ws-builder-number-input",
                type: "number",
                min: "0",
                max: SPACING_INPUT_MAX,
                value: length.value,
                onChange: function onChange(e) {
                  return updatePaddingSide(side.key, e.target.value, length.unit);
                },
                style: spacingInputStyle
              }), /*#__PURE__*/_jsx(UnitSelect, {
                value: length.unit,
                units: SPACING_UNITS,
                onChange: function onChange(unit) {
                  return updatePaddingSide(side.key, length.value, unit);
                }
              })]
            })]
          }, side.key);
        })
      })]
    })]
  });
}
var COLUMN_ALIGN_OPTIONS = [{
  value: "stretch",
  label: "Stretch"
}, {
  value: "flex-start",
  label: "Start"
}, {
  value: "center",
  label: "Center"
}, {
  value: "flex-end",
  label: "End"
}];
var COLUMN_JUSTIFY_OPTIONS = [{
  value: "flex-start",
  label: "Start"
}, {
  value: "center",
  label: "Center"
}, {
  value: "flex-end",
  label: "End"
}, {
  value: "space-between",
  label: "Space between"
}, {
  value: "space-around",
  label: "Space around"
}, {
  value: "space-evenly",
  label: "Space evenly"
}];
export function ColumnFlexControls(_ref5) {
  var _ref5$alignValue = _ref5.alignValue,
    alignValue = _ref5$alignValue === void 0 ? "" : _ref5$alignValue,
    _ref5$justifyValue = _ref5.justifyValue,
    justifyValue = _ref5$justifyValue === void 0 ? "" : _ref5$justifyValue,
    onUpdateAlign = _ref5.onUpdateAlign,
    onUpdateJustify = _ref5.onUpdateJustify;
  var selectStyle = _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
    fontFamily: "DM Sans, sans-serif",
    fontWeight: 500,
    fontSize: 13
  });
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 8
    },
    children: [/*#__PURE__*/_jsx("span", {
      style: {
        fontSize: 12,
        fontWeight: 500,
        color: "#6b7280",
        textTransform: "uppercase",
        letterSpacing: "0.04em"
      },
      children: "Flex"
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6
      },
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          fontSize: 12,
          color: "#6b7280"
        },
        children: "Align items"
      }), /*#__PURE__*/_jsx("select", {
        value: alignValue || "stretch",
        onChange: function onChange(e) {
          return onUpdateAlign(e.target.value);
        },
        style: selectStyle,
        children: COLUMN_ALIGN_OPTIONS.map(function (opt) {
          return /*#__PURE__*/_jsx("option", {
            value: opt.value,
            children: opt.label
          }, opt.value);
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6
      },
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          fontSize: 12,
          color: "#6b7280"
        },
        children: "Justify content"
      }), /*#__PURE__*/_jsx("select", {
        value: justifyValue || "flex-start",
        onChange: function onChange(e) {
          return onUpdateJustify(e.target.value);
        },
        style: selectStyle,
        children: COLUMN_JUSTIFY_OPTIONS.map(function (opt) {
          return /*#__PURE__*/_jsx("option", {
            value: opt.value,
            children: opt.label
          }, opt.value);
        })
      })]
    })]
  });
}
export function ColumnBorderControls(_ref6) {
  var _ref6$styleValue = _ref6.styleValue,
    styleValue = _ref6$styleValue === void 0 ? "" : _ref6$styleValue,
    _ref6$widthValue = _ref6.widthValue,
    widthValue = _ref6$widthValue === void 0 ? "" : _ref6$widthValue,
    _ref6$colorValue = _ref6.colorValue,
    colorValue = _ref6$colorValue === void 0 ? "" : _ref6$colorValue,
    _ref6$radiusValue = _ref6.radiusValue,
    radiusValue = _ref6$radiusValue === void 0 ? "" : _ref6$radiusValue,
    onUpdateBorder = _ref6.onUpdateBorder,
    onUpdateStyle = _ref6.onUpdateStyle,
    onUpdateWidth = _ref6.onUpdateWidth,
    onUpdateColor = _ref6.onUpdateColor,
    onUpdateRadius = _ref6.onUpdateRadius;
  var currentStyle = styleValue || "none";
  var hasBorder = currentStyle !== "none";
  var color = colorValue || "#cbd5e1";
  var widthParts = String(widthValue || "").trim().split(/\s+/).filter(Boolean);
  var linked = widthParts.length <= 1;
  var allWidth = parseCssLength(widthParts[0] !== undefined && widthParts[0] !== "" ? widthParts[0] : hasBorder ? "1px" : "0px", hasBorder ? 1 : 0, "px");
  var radiusLength = parseCssLength(radiusValue || (hasBorder ? "8px" : "0px"), 0, "px");
  var canClear = hasBorder || allWidth.value > 0 || radiusLength.value > 0;
  var updateWidthAll = function updateWidthAll(val) {
    var num = Math.max(0, parseInt(val, 10) || 0);
    onUpdateWidth("".concat(num, "px"));
  };
  var updateWidthSide = function updateWidthSide(sideKey, val) {
    var num = Math.max(0, parseInt(val, 10) || 0);
    var next = {};
    SPACING_SIDES.forEach(function (side) {
      var length = getShorthandSideLength(widthValue, side.key, 1, "px");
      next[side.key] = "".concat(length.value, "px");
    });
    next[sideKey] = "".concat(num, "px");
    onUpdateWidth("".concat(next.Top, " ").concat(next.Right, " ").concat(next.Bottom, " ").concat(next.Left));
  };
  var toggleWidthMode = function toggleWidthMode() {
    if (linked) {
      var v = "".concat(allWidth.value, "px");
      onUpdateWidth("".concat(v, " ").concat(v, " ").concat(v, " ").concat(v));
      return;
    }
    var top = getShorthandSideLength(widthValue, "Top", 1, "px");
    onUpdateWidth("".concat(top.value, "px"));
  };
  var selectStyle = _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
    fontFamily: "DM Sans, sans-serif",
    fontWeight: 500,
    fontSize: 13
  });
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      padding: 10,
      background: "#f8fafc",
      border: "1px solid ".concat(UI.inputBorder),
      borderRadius: 8
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      },
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          fontSize: 12,
          fontWeight: 500,
          color: "#6b7280",
          textTransform: "uppercase",
          letterSpacing: "0.04em"
        },
        children: "Border"
      }), canClear && /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: function onClick() {
          if (typeof onUpdateBorder === "function") {
            onUpdateBorder({
              columnBorderStyles: "none",
              columnBorderWidths: "0px",
              columnBorderRadii: "0px"
            });
          } else {
            onUpdateStyle("none");
            onUpdateWidth("0px");
            if (typeof onUpdateRadius === "function") {
              onUpdateRadius("0px");
            }
          }
        },
        title: "Remove border and radius",
        style: {
          background: "#ffffff",
          border: "1px solid ".concat(UI.inputBorder),
          borderRadius: 6,
          color: "#ef4444",
          padding: "2px 8px",
          fontSize: 11,
          cursor: "pointer",
          fontWeight: 500
        },
        children: "Clear"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6
      },
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          fontSize: 12,
          color: "#6b7280"
        },
        children: "Border Style"
      }), /*#__PURE__*/_jsxs("select", {
        value: currentStyle,
        onChange: function onChange(e) {
          var next = e.target.value;
          if (next !== "none") {
            var defaultWidth = widthValue && widthValue !== "0px" ? widthValue : "1px";
            var defaultColor = colorValue || "#cbd5e1";
            var defaultRadius = radiusValue || "8px";
            if (typeof onUpdateBorder === "function") {
              onUpdateBorder({
                columnBorderStyles: next,
                columnBorderWidths: defaultWidth,
                columnBorderColors: defaultColor,
                columnBorderRadii: defaultRadius
              });
            } else {
              onUpdateStyle(next);
            }
          } else {
            if (typeof onUpdateBorder === "function") {
              onUpdateBorder({
                columnBorderStyles: "none"
              });
            } else {
              onUpdateStyle("none");
            }
          }
        },
        style: selectStyle,
        children: [/*#__PURE__*/_jsx("option", {
          value: "none",
          children: "None"
        }), /*#__PURE__*/_jsx("option", {
          value: "solid",
          children: "Solid"
        }), /*#__PURE__*/_jsx("option", {
          value: "dashed",
          children: "Dashed"
        }), /*#__PURE__*/_jsx("option", {
          value: "dotted",
          children: "Dotted"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6
      },
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        },
        children: [/*#__PURE__*/_jsx("span", {
          style: {
            fontSize: 12,
            color: "#6b7280"
          },
          children: "Border Width"
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: toggleWidthMode,
          title: linked ? "Edit each side separately" : "Link all sides",
          style: {
            background: linked ? "#F2F4F7" : "#101828",
            border: "1px solid ".concat(linked ? UI.inputBorder : "#101828"),
            borderRadius: 6,
            color: linked ? "#4b5563" : "#ffffff",
            padding: "2px 8px",
            fontSize: 11,
            cursor: "pointer",
            fontWeight: 600
          },
          children: linked ? "All Sides" : "Per Side"
        })]
      }), linked ? /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: 6
        },
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: 8
          },
          children: [/*#__PURE__*/_jsx("input", {
            className: "ws-builder-number-input",
            type: "number",
            min: "0",
            max: "20",
            value: allWidth.value !== undefined && allWidth.value !== null ? allWidth.value : 0,
            onChange: function onChange(e) {
              return updateWidthAll(e.target.value);
            },
            style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
              width: 64,
              padding: "5px 6px",
              fontSize: 12
            })
          }), /*#__PURE__*/_jsx("span", {
            style: {
              fontSize: 12,
              color: "#64748b"
            },
            children: "px (all sides)"
          })]
        }), /*#__PURE__*/_jsx("input", {
          type: "range",
          min: "0",
          max: "20",
          value: allWidth.value !== undefined && allWidth.value !== null ? allWidth.value : 0,
          onChange: function onChange(e) {
            return updateWidthAll(e.target.value);
          },
          style: {
            width: "100%",
            cursor: "pointer",
            accentColor: "#101828"
          }
        })]
      }) : /*#__PURE__*/_jsx("div", {
        style: {
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 6
        },
        children: SPACING_SIDES.map(function (side) {
          var length = getShorthandSideLength(widthValue, side.key, 1, "px");
          return /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 2
            },
            children: [/*#__PURE__*/_jsx("span", {
              style: {
                fontSize: 10,
                color: "#6b7280",
                textTransform: "uppercase"
              },
              children: side.label
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                alignItems: "center",
                gap: 4
              },
              children: [/*#__PURE__*/_jsx("input", {
                className: "ws-builder-number-input",
                type: "number",
                min: "0",
                max: "20",
                value: length.value,
                onChange: function onChange(e) {
                  return updateWidthSide(side.key, e.target.value);
                },
                style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
                  padding: "4px 6px",
                  fontSize: 12
                })
              }), /*#__PURE__*/_jsx("span", {
                style: {
                  fontSize: 11,
                  color: "#94a3b8"
                },
                children: "px"
              })]
            })]
          }, side.key);
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6
      },
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          fontSize: 12,
          color: "#6b7280"
        },
        children: "Border Color"
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: 8
        },
        children: [/*#__PURE__*/_jsx("input", {
          type: "color",
          value: color.startsWith("#") ? color : "#cbd5e1",
          onChange: function onChange(e) {
            return onUpdateColor(e.target.value);
          },
          style: {
            width: 32,
            height: 32,
            padding: 0,
            border: "1px solid ".concat(UI.inputBorder),
            borderRadius: 6,
            cursor: "pointer"
          }
        }), /*#__PURE__*/_jsx("input", {
          type: "text",
          value: color,
          onChange: function onChange(e) {
            return onUpdateColor(e.target.value);
          },
          placeholder: "#cbd5e1",
          style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
            flex: 1,
            padding: "6px 8px",
            fontSize: 12
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6
      },
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        },
        children: [/*#__PURE__*/_jsx("span", {
          style: {
            fontSize: 12,
            color: "#6b7280"
          },
          children: "Corner Radius"
        }), /*#__PURE__*/_jsxs("span", {
          style: {
            fontSize: 11,
            color: "#64748b"
          },
          children: [radiusLength.value, "px"]
        })]
      }), /*#__PURE__*/_jsx("input", {
        type: "range",
        min: "0",
        max: "32",
        value: radiusLength.value,
        onChange: function onChange(e) {
          return onUpdateRadius("".concat(e.target.value, "px"));
        },
        style: {
          width: "100%",
          cursor: "pointer",
          accentColor: "#101828"
        }
      })]
    })]
  });
}
export function GapControls(_ref7) {
  var style = _ref7.style,
    onUpdate = _ref7.onUpdate,
    onClear = _ref7.onClear,
    _ref7$defaultGap = _ref7.defaultGap,
    defaultGap = _ref7$defaultGap === void 0 ? 0 : _ref7$defaultGap,
    _ref7$label = _ref7.label,
    label = _ref7$label === void 0 ? "Gap" : _ref7$label,
    _ref7$sublabel = _ref7.sublabel,
    sublabel = _ref7$sublabel === void 0 ? "Space between items" : _ref7$sublabel;
  var length = parseCssLength(style === null || style === void 0 ? void 0 : style.gap, defaultGap);
  var hasGap = length.value !== 0;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 10
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      },
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          fontSize: 14,
          fontWeight: 500,
          color: "#4b5563"
        },
        children: label
      }), typeof onClear === "function" && /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: onClear,
        disabled: !hasGap,
        title: "Remove ".concat(label.toLowerCase(), " (set to 0)"),
        style: {
          background: hasGap ? "#ffffff" : "#F2F4F7",
          border: "1px solid ".concat(UI.inputBorder),
          borderRadius: 6,
          color: hasGap ? "#4b5563" : "#94a3b8",
          padding: "4px 10px",
          fontSize: 11,
          cursor: hasGap ? "pointer" : "default",
          fontWeight: 600,
          fontFamily: "DM Sans, sans-serif",
          transition: "all 0.15s",
          opacity: hasGap ? 1 : 0.7
        },
        children: "None"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6
      },
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: 12,
          fontWeight: 500
        },
        children: [/*#__PURE__*/_jsx("span", {
          style: {
            color: "#6b7280"
          },
          children: sublabel
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: 6
          },
          children: [/*#__PURE__*/_jsx("input", {
            className: "ws-builder-number-input",
            type: "number",
            min: "0",
            max: SPACING_INPUT_MAX,
            value: length.value,
            onChange: function onChange(e) {
              return onUpdate(formatCssLength(e.target.value, length.unit));
            },
            style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
              width: 64,
              padding: "5px 6px",
              fontSize: 12
            })
          }), /*#__PURE__*/_jsx(UnitSelect, {
            value: length.unit,
            units: SPACING_UNITS,
            onChange: function onChange(unit) {
              return onUpdate(formatCssLength(length.value, unit));
            }
          })]
        })]
      }), /*#__PURE__*/_jsx("input", {
        type: "range",
        min: 0,
        max: SPACING_SLIDER_MAX,
        value: length.value,
        onChange: function onChange(e) {
          return onUpdate(formatCssLength(e.target.value, length.unit));
        },
        style: {
          width: "100%",
          cursor: "pointer",
          accentColor: "#101828"
        }
      })]
    })]
  });
}
export function SpacingControls(_ref8) {
  var _style;
  var label = _ref8.label,
    property = _ref8.property,
    style = _ref8.style,
    onUpdateSide = _ref8.onUpdateSide,
    onUpdateAll = _ref8.onUpdateAll,
    onUnlink = _ref8.onUnlink,
    onClear = _ref8.onClear,
    _ref8$allowNegative = _ref8.allowNegative,
    allowNegative = _ref8$allowNegative === void 0 ? false : _ref8$allowNegative;
  var linked = !hasIndividualSpacing(style, property);
  var allLength = parseCssLength((_style = style === null || style === void 0 ? void 0 : style[property + "Top"]) !== null && _style !== void 0 ? _style : style === null || style === void 0 ? void 0 : style[property], getSpacingSideValue(style, property, "Top"));
  var hasSpacing = hasIndividualSpacing(style, property) ? SPACING_SIDES.some(function (side) {
    return getSpacingSideValue(style, property, side.key) !== 0;
  }) : allLength.value !== 0;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 10
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      },
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          fontSize: 14,
          fontWeight: 500,
          color: "#4b5563"
        },
        children: label
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: 6
        },
        children: [typeof onClear === "function" && /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: onClear,
          disabled: !hasSpacing,
          title: "Remove ".concat(label.toLowerCase(), " (set to 0)"),
          style: {
            background: hasSpacing ? "#ffffff" : "#F2F4F7",
            border: "1px solid ".concat(UI.inputBorder),
            borderRadius: 6,
            color: hasSpacing ? "#4b5563" : "#94a3b8",
            padding: "4px 10px",
            fontSize: 11,
            cursor: hasSpacing ? "pointer" : "default",
            fontWeight: 600,
            fontFamily: "DM Sans, sans-serif",
            transition: "all 0.15s",
            opacity: hasSpacing ? 1 : 0.7
          },
          children: "None"
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: onUnlink,
          title: linked ? "Edit each side separately" : "Link all sides",
          style: {
            background: linked ? "#F2F4F7" : "#101828",
            border: "1px solid ".concat(linked ? UI.inputBorder : "#101828"),
            borderRadius: 6,
            color: linked ? "#4b5563" : "#ffffff",
            padding: "4px 10px",
            fontSize: 11,
            cursor: "pointer",
            fontWeight: 600,
            fontFamily: "DM Sans, sans-serif",
            transition: "all 0.15s"
          },
          children: linked ? "All Sides" : "Per Side"
        })]
      })]
    }), linked ? /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6
      },
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: 12,
          fontWeight: 500
        },
        children: [/*#__PURE__*/_jsx("span", {
          style: {
            color: "#6b7280"
          },
          children: "Uniform"
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: 6
          },
          children: [/*#__PURE__*/_jsx("input", {
            className: "ws-builder-number-input",
            type: "number",
            min: allowNegative ? undefined : "0",
            max: SPACING_INPUT_MAX,
            value: allLength.value,
            onChange: function onChange(e) {
              return onUpdateAll(e.target.value, allLength.unit);
            },
            style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
              width: 64,
              padding: "5px 6px",
              fontSize: 12
            })
          }), /*#__PURE__*/_jsx(UnitSelect, {
            value: allLength.unit,
            units: SPACING_UNITS,
            onChange: function onChange(unit) {
              return onUpdateAll(allLength.value, unit);
            }
          })]
        })]
      }), /*#__PURE__*/_jsx("input", {
        type: "range",
        min: allowNegative ? -SPACING_SLIDER_MAX : 0,
        max: SPACING_SLIDER_MAX,
        value: allLength.value,
        onChange: function onChange(e) {
          return onUpdateAll(e.target.value, allLength.unit);
        },
        style: {
          width: "100%",
          cursor: "pointer",
          accentColor: "#101828"
        }
      })]
    }) : /*#__PURE__*/_jsx("div", {
      style: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 6
      },
      children: SPACING_SIDES.map(function (side) {
        var length = parseCssLength(style === null || style === void 0 ? void 0 : style[property + side.key], getSpacingSideValue(style, property, side.key));
        return /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: 4
          },
          children: [/*#__PURE__*/_jsx("label", {
            style: {
              fontSize: 10,
              color: "#6b7280",
              textTransform: "uppercase",
              letterSpacing: "0.04em"
            },
            children: side.label
          }), /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              alignItems: "center",
              gap: 4
            },
            children: [/*#__PURE__*/_jsx("input", {
              className: "ws-builder-number-input",
              type: "number",
              min: allowNegative ? undefined : "0",
              max: SPACING_INPUT_MAX,
              value: length.value,
              onChange: function onChange(e) {
                return onUpdateSide(side.key, e.target.value, length.unit);
              },
              style: spacingInputStyle
            }), /*#__PURE__*/_jsx(UnitSelect, {
              value: length.unit,
              units: SPACING_UNITS,
              onChange: function onChange(unit) {
                return onUpdateSide(side.key, length.value, unit);
              }
            })]
          })]
        }, side.key);
      })
    })]
  });
}
export function RadiusControls(_ref9) {
  var style = _ref9.style,
    onUpdateCorner = _ref9.onUpdateCorner,
    onUpdateAll = _ref9.onUpdateAll,
    onUnlink = _ref9.onUnlink;
  var linked = !hasIndividualRadius(style);
  var allLength = getRadiusCornerLength(style, "borderTopLeftRadius");
  var sliderMax = RADIUS_SLIDER_MAX_BY_UNIT[allLength.unit] || RADIUS_SLIDER_MAX_BY_UNIT.px;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 10
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      },
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          fontSize: 14,
          fontWeight: 500,
          color: "#4b5563"
        },
        children: "Corner Radius"
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: onUnlink,
        title: linked ? "Edit each corner separately" : "Link all corners",
        style: {
          background: linked ? "#F2F4F7" : "#101828",
          border: "1px solid ".concat(linked ? UI.inputBorder : "#101828"),
          borderRadius: 6,
          color: linked ? "#4b5563" : "#ffffff",
          padding: "4px 10px",
          fontSize: 11,
          cursor: "pointer",
          fontWeight: 600,
          fontFamily: "DM Sans, sans-serif",
          transition: "all 0.15s"
        },
        children: linked ? "All Corners" : "Per Corner"
      })]
    }), linked ? /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6
      },
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: 12
        },
        children: [/*#__PURE__*/_jsx("span", {
          style: {
            color: "#6b7280"
          },
          children: "Uniform"
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: 6
          },
          children: [/*#__PURE__*/_jsx("input", {
            className: "ws-builder-number-input",
            type: "number",
            min: "0",
            max: RADIUS_INPUT_MAX_BY_UNIT[allLength.unit] || RADIUS_INPUT_MAX_BY_UNIT.px,
            step: allLength.unit === "px" ? 1 : 0.1,
            value: allLength.value,
            onChange: function onChange(e) {
              return onUpdateAll(e.target.value, allLength.unit);
            },
            style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
              width: 64,
              padding: "5px 6px",
              fontSize: 12
            })
          }), /*#__PURE__*/_jsx(UnitSelect, {
            value: allLength.unit,
            units: RADIUS_UNITS,
            onChange: function onChange(unit) {
              return onUpdateAll(allLength.value, unit);
            }
          })]
        })]
      }), /*#__PURE__*/_jsx("input", {
        type: "range",
        min: "0",
        max: sliderMax,
        value: Math.min(allLength.value, sliderMax),
        onChange: function onChange(e) {
          return onUpdateAll(e.target.value, allLength.unit);
        },
        style: {
          width: "100%",
          cursor: "pointer",
          accentColor: "#101828"
        }
      })]
    }) : /*#__PURE__*/_jsx("div", {
      style: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 6
      },
      children: RADIUS_CORNERS.map(function (corner) {
        var length = getRadiusCornerLength(style, corner.key);
        var cornerInputMax = RADIUS_INPUT_MAX_BY_UNIT[length.unit] || RADIUS_INPUT_MAX_BY_UNIT.px;
        return /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: 4
          },
          children: [/*#__PURE__*/_jsx("label", {
            style: {
              fontSize: 10,
              color: "#6b7280",
              textTransform: "uppercase",
              letterSpacing: "0.04em"
            },
            children: corner.label
          }), /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              alignItems: "center",
              gap: 4
            },
            children: [/*#__PURE__*/_jsx("input", {
              className: "ws-builder-number-input",
              type: "number",
              min: "0",
              max: cornerInputMax,
              step: length.unit === "px" ? 1 : 0.1,
              value: length.value,
              onChange: function onChange(e) {
                return onUpdateCorner(corner.key, e.target.value, length.unit);
              },
              style: spacingInputStyle
            }), /*#__PURE__*/_jsx(UnitSelect, {
              value: length.unit,
              units: RADIUS_UNITS,
              onChange: function onChange(unit) {
                return onUpdateCorner(corner.key, length.value, unit);
              }
            })]
          })]
        }, corner.key);
      })
    })]
  });
}
export function TableBorderControls(_ref10) {
  var _ref10$styleValue = _ref10.styleValue,
    styleValue = _ref10$styleValue === void 0 ? "solid" : _ref10$styleValue,
    _ref10$widthValue = _ref10.widthValue,
    widthValue = _ref10$widthValue === void 0 ? "1px" : _ref10$widthValue,
    _ref10$colorValue = _ref10.colorValue,
    colorValue = _ref10$colorValue === void 0 ? "#e2e8f0" : _ref10$colorValue,
    onChangeStyle = _ref10.onChangeStyle,
    onChangeWidth = _ref10.onChangeWidth,
    onReset = _ref10.onReset;
  var topW = getShorthandSideLength(widthValue, "Top", 1, "px").value;
  var rightW = getShorthandSideLength(widthValue, "Right", 1, "px").value;
  var bottomW = getShorthandSideLength(widthValue, "Bottom", 1, "px").value;
  var leftW = getShorthandSideLength(widthValue, "Left", 1, "px").value;
  var widthParts = String(widthValue || "").trim().split(/\s+/).filter(Boolean);
  var _React$useState = React.useState(widthParts.length > 1),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    unlinked = _React$useState2[0],
    setUnlinked = _React$useState2[1];
  React.useEffect(function () {
    var parts = String(widthValue || "").trim().split(/\s+/).filter(Boolean);
    setUnlinked(parts.length > 1);
  }, [widthValue]);
  var isNoneStyle = styleValue === "none";
  var canReset = styleValue && styleValue !== "solid" || widthValue && widthValue !== "1px" || colorValue && colorValue !== "#e2e8f0";
  var hasBorderWidth = topW > 0 || rightW > 0 || bottomW > 0 || leftW > 0;
  var updateSideWidth = function updateSideWidth(sideKey, val) {
    var num = Math.max(0, parseInt(val, 10) || 0);
    var sides = {
      Top: topW,
      Right: rightW,
      Bottom: bottomW,
      Left: leftW
    };
    sides[sideKey] = num;
    setUnlinked(true);
    if (num > 0 && styleValue === "none") {
      onChangeStyle("solid");
    }
    onChangeWidth("".concat(sides.Top, "px ").concat(sides.Right, "px ").concat(sides.Bottom, "px ").concat(sides.Left, "px"));
  };
  var updateAllWidth = function updateAllWidth(val) {
    var num = Math.max(0, parseInt(val, 10) || 0);
    if (num > 0 && styleValue === "none") {
      onChangeStyle("solid");
    }
    setUnlinked(false);
    onChangeWidth("".concat(num, "px"));
  };
  var toggleWidthMode = function toggleWidthMode() {
    if (!unlinked) {
      var current = "".concat(topW, "px ").concat(rightW, "px ").concat(bottomW, "px ").concat(leftW, "px");
      onChangeWidth(current);
      setUnlinked(true);
    } else {
      onChangeWidth("".concat(topW, "px"));
      setUnlinked(false);
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 12
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6
      },
      children: [/*#__PURE__*/_jsx("label", {
        style: {
          fontSize: 12,
          fontWeight: 500,
          color: "#4b5563"
        },
        children: "Grid Border Style"
      }), /*#__PURE__*/_jsxs("select", {
        value: styleValue || "solid",
        onChange: function onChange(e) {
          return onChangeStyle(e.target.value);
        },
        style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
          padding: "6px 10px",
          fontFamily: "DM Sans, sans-serif",
          fontSize: 13,
          fontWeight: 500,
          cursor: "pointer"
        }),
        children: [/*#__PURE__*/_jsx("option", {
          value: "solid",
          children: "Solid"
        }), /*#__PURE__*/_jsx("option", {
          value: "dashed",
          children: "Dashed"
        }), /*#__PURE__*/_jsx("option", {
          value: "dotted",
          children: "Dotted"
        }), /*#__PURE__*/_jsx("option", {
          value: "none",
          children: "None (No Grid Lines)"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6
      },
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        },
        children: [/*#__PURE__*/_jsx("label", {
          style: {
            fontSize: 12,
            fontWeight: 500,
            color: "#4b5563"
          },
          children: "Border Width"
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: 6
          },
          children: [hasBorderWidth && /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: function onClick() {
              return updateAllWidth(0);
            },
            style: {
              background: "#ffffff",
              border: "1px solid ".concat(UI.inputBorder),
              borderRadius: 6,
              color: "#ef4444",
              padding: "2px 8px",
              fontSize: 10,
              cursor: "pointer",
              fontWeight: 600,
              fontFamily: "DM Sans, sans-serif"
            },
            title: "Remove border (set to 0)",
            children: "None"
          }), /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: toggleWidthMode,
            style: {
              background: !unlinked ? "#F2F4F7" : "#101828",
              border: "1px solid ".concat(!unlinked ? UI.inputBorder : "#101828"),
              borderRadius: 6,
              color: !unlinked ? "#4b5563" : "#ffffff",
              padding: "3px 8px",
              fontSize: 10,
              cursor: "pointer",
              fontWeight: 600,
              fontFamily: "DM Sans, sans-serif",
              transition: "all 0.15s"
            },
            children: !unlinked ? "All Sides" : "Per Side"
          })]
        })]
      }), !unlinked ? /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: 8
        },
        children: [/*#__PURE__*/_jsx("input", {
          type: "range",
          min: "0",
          max: "8",
          value: topW,
          onChange: function onChange(e) {
            return updateAllWidth(e.target.value);
          },
          style: {
            flex: 1,
            cursor: "pointer",
            accentColor: "#101828"
          }
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: 4
          },
          children: [/*#__PURE__*/_jsx("input", {
            className: "ws-builder-number-input",
            type: "number",
            min: "0",
            max: "8",
            value: topW,
            onChange: function onChange(e) {
              return updateAllWidth(e.target.value);
            },
            style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
              width: 50,
              textAlign: "center",
              padding: "4px 6px",
              fontSize: 12
            })
          }), /*#__PURE__*/_jsx("span", {
            style: {
              fontSize: 11,
              color: "#94a3b8"
            },
            children: "px"
          })]
        })]
      }) : /*#__PURE__*/_jsx("div", {
        style: {
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 6
        },
        children: [{
          key: "Top",
          label: "Top",
          val: topW
        }, {
          key: "Bottom",
          label: "Bottom",
          val: bottomW
        }, {
          key: "Left",
          label: "Left",
          val: leftW
        }, {
          key: "Right",
          label: "Right",
          val: rightW
        }].map(function (side) {
          return /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 3
            },
            children: [/*#__PURE__*/_jsx("span", {
              style: {
                fontSize: 10,
                color: "#64748b",
                fontWeight: 600,
                textTransform: "uppercase"
              },
              children: side.label
            }), /*#__PURE__*/_jsx("div", {
              style: {
                display: "flex",
                alignItems: "center",
                gap: 2
              },
              children: /*#__PURE__*/_jsx("input", {
                className: "ws-builder-number-input",
                type: "number",
                min: "0",
                max: "8",
                value: side.val,
                onChange: function onChange(e) {
                  return updateSideWidth(side.key, e.target.value);
                },
                style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
                  padding: "4px 6px",
                  fontSize: 12,
                  textAlign: "center"
                })
              })
            })]
          }, side.key);
        })
      })]
    })]
  });
}
export function TableCellPaddingControls(_ref11) {
  var _ref11$paddingValue = _ref11.paddingValue,
    paddingValue = _ref11$paddingValue === void 0 ? "10px" : _ref11$paddingValue,
    onChangePadding = _ref11.onChangePadding;
  var topPad = getShorthandSideLength(paddingValue, "Top", 10, "px").value;
  var rightPad = getShorthandSideLength(paddingValue, "Right", 10, "px").value;
  var bottomPad = getShorthandSideLength(paddingValue, "Bottom", 10, "px").value;
  var leftPad = getShorthandSideLength(paddingValue, "Left", 10, "px").value;
  var padParts = String(paddingValue || "").trim().split(/\s+/).filter(Boolean);
  var _React$useState3 = React.useState(padParts.length > 1),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    unlinked = _React$useState4[0],
    setUnlinked = _React$useState4[1];
  React.useEffect(function () {
    var parts = String(paddingValue || "").trim().split(/\s+/).filter(Boolean);
    setUnlinked(parts.length > 1);
  }, [paddingValue]);
  var hasPadding = topPad > 0 || rightPad > 0 || bottomPad > 0 || leftPad > 0;
  var updateSidePad = function updateSidePad(sideKey, val) {
    var num = Math.max(0, parseInt(val, 10) || 0);
    var sides = {
      Top: topPad,
      Right: rightPad,
      Bottom: bottomPad,
      Left: leftPad
    };
    sides[sideKey] = num;
    setUnlinked(true);
    onChangePadding("".concat(sides.Top, "px ").concat(sides.Right, "px ").concat(sides.Bottom, "px ").concat(sides.Left, "px"));
  };
  var updateAllPad = function updateAllPad(val) {
    var num = Math.max(0, parseInt(val, 10) || 0);
    setUnlinked(false);
    onChangePadding("".concat(num, "px"));
  };
  var togglePaddingMode = function togglePaddingMode() {
    if (!unlinked) {
      var current = "".concat(topPad, "px ").concat(rightPad, "px ").concat(bottomPad, "px ").concat(leftPad, "px");
      onChangePadding(current);
      setUnlinked(true);
    } else {
      onChangePadding("".concat(topPad, "px"));
      setUnlinked(false);
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 8
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      },
      children: [/*#__PURE__*/_jsx("label", {
        style: {
          fontSize: 12,
          fontWeight: 500,
          color: "#4b5563"
        },
        children: "Cell Padding"
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: 6
        },
        children: [hasPadding && /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: function onClick() {
            return updateAllPad(0);
          },
          style: {
            background: "#ffffff",
            border: "1px solid ".concat(UI.inputBorder),
            borderRadius: 6,
            color: "#ef4444",
            padding: "2px 8px",
            fontSize: 10,
            cursor: "pointer",
            fontWeight: 600,
            fontFamily: "DM Sans, sans-serif"
          },
          title: "Remove cell padding (set to 0)",
          children: "None"
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: togglePaddingMode,
          style: {
            background: !unlinked ? "#F2F4F7" : "#101828",
            border: "1px solid ".concat(!unlinked ? UI.inputBorder : "#101828"),
            borderRadius: 6,
            color: !unlinked ? "#4b5563" : "#ffffff",
            padding: "3px 8px",
            fontSize: 10,
            cursor: "pointer",
            fontWeight: 600,
            fontFamily: "DM Sans, sans-serif",
            transition: "all 0.15s"
          },
          children: !unlinked ? "All Sides" : "Per Side"
        })]
      })]
    }), !unlinked ? /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: 8
      },
      children: [/*#__PURE__*/_jsx("input", {
        type: "range",
        min: "0",
        max: "32",
        value: topPad,
        onChange: function onChange(e) {
          return updateAllPad(e.target.value);
        },
        style: {
          flex: 1,
          cursor: "pointer",
          accentColor: "#101828"
        }
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: 4
        },
        children: [/*#__PURE__*/_jsx("input", {
          className: "ws-builder-number-input",
          type: "number",
          min: "0",
          max: "60",
          value: topPad,
          onChange: function onChange(e) {
            return updateAllPad(e.target.value);
          },
          style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
            width: 50,
            textAlign: "center",
            padding: "4px 6px",
            fontSize: 12
          })
        }), /*#__PURE__*/_jsx("span", {
          style: {
            fontSize: 11,
            color: "#94a3b8"
          },
          children: "px"
        })]
      })]
    }) : /*#__PURE__*/_jsx("div", {
      style: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: 6
      },
      children: [{
        key: "Top",
        label: "Top",
        val: topPad
      }, {
        key: "Bottom",
        label: "Bottom",
        val: bottomPad
      }, {
        key: "Left",
        label: "Left",
        val: leftPad
      }, {
        key: "Right",
        label: "Right",
        val: rightPad
      }].map(function (side) {
        return /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: 3
          },
          children: [/*#__PURE__*/_jsx("span", {
            style: {
              fontSize: 10,
              color: "#64748b",
              fontWeight: 600,
              textTransform: "uppercase"
            },
            children: side.label
          }), /*#__PURE__*/_jsx("div", {
            style: {
              display: "flex",
              alignItems: "center",
              gap: 2
            },
            children: /*#__PURE__*/_jsx("input", {
              className: "ws-builder-number-input",
              type: "number",
              min: "0",
              max: "60",
              value: side.val,
              onChange: function onChange(e) {
                return updateSidePad(side.key, e.target.value);
              },
              style: _objectSpread(_objectSpread({}, spacingInputStyle), {}, {
                padding: "4px 6px",
                fontSize: 12,
                textAlign: "center"
              })
            })
          })]
        }, side.key);
      })
    })]
  });
}